import { Tag } from '@chakra-ui/react';


export enum EmailEvents {
  Send = 'Envio',
  Delivery = 'Entrega',
  Open = 'Abertura',
  Click = 'Clique',
  Bounce = 'Devolução',
  Complaint = 'Reclamação',
  Reject = 'Rejeição',
  DeliveryDelay = 'Atraso na entrega',
  Subscription = 'Cancelamento de inscrição'
}

interface Props {
  event: keyof typeof EmailEvents
}

export default function TagEmailEvent({ event }: Props ) {
  return (
    <Tag 
      flexShrink={0}
      size="sm"
      colorScheme="gray"
      variant="outline"
    >
      {EmailEvents[event] ?? event}
    </Tag>
  )
}